/*
 * <kg-video> — Killergolf 자체 영상 컨트롤러
 * Xotiny(Futurer) 테마의 벤더 컴포넌트 <xo-intersection-video> 를 대체한다.
 *
 * 설계 원칙: "한 영상 = 한 주인"
 *   - 이 엘리먼트는 자기 안의 <video> "단 하나"만 제어한다. 다른 영상은 절대 건드리지 않는다.
 *   - 뷰포트에 보이면 재생, 벗어나면 정지(배터리 절약). loop/muted 는 <video> 속성을 그대로 따른다.
 *   - 안에 <video> 가 없으면(youtube/vimeo iframe 등) 아무 것도 하지 않고 통과만 시킨다.
 *
 * 과거 버그(스트로브 = "영상이 빨리 도는 현상"):
 *   벤더 handlePauseAll("다른 영상 전부 정지")  vs  theme.liquid forcePlay("절대 정지 금지")
 *   두 정책이 같은 <video> 를 두고 충돌 → pause↔play 무한 핑퐁.
 *   이 컴포넌트는 "전부 정지"도 "절대 정지 금지"도 하지 않으므로,
 *   충돌할 주체가 아예 없어 핑퐁이 구조적으로 불가능하다.
 */
(function () {
  if (window.customElements && customElements.get('kg-video')) return;

  class KgVideo extends HTMLElement {
    connectedCallback() {
      if (this._io) return; // 중복 연결 방지(테마 에디터 재마운트 등)
      var video = this.querySelector('video');
      if (!video) return;   // iframe(youtube/vimeo) 등 → 제어하지 않고 통과

      video.muted = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      var play = function () {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      };

      // 뷰포트에 들어오면 재생, 벗어나면 정지.
      // (벤더 handleIntersection 의 '좋은 부분'만 계승 — "다른 영상 일괄 정지"는 버림)
      // display:none 인 영상(숨겨진 모바일/데스크톱 변형)은 isIntersecting=false → 자동 정지된다.
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) play();
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.25 });
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) { this._io.disconnect(); this._io = null; }
    }
  }

  customElements.define('kg-video', KgVideo);
})();
